module.exports = __webpack_public_path__ + "img/fusee.a6b7652e.svg";